import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import PublicRoutes from './_config/publicRoutes';
import { URLS } from './_config';
import Login from './pages/Auth/login';
import PrivateRoutes from './_config/privateRoutes';
import Home from './pages/home';
import Page404 from './pages/404';

import Profile from './pages/profile';
import Registration from './pages/Auth/registration';
import ForgotPassword from './pages/Auth/forgotPassword';
import ResetPassword from './pages/Auth/resetPassword';
import Facilities from './pages/Facilities';
import Assets from './pages/Assets';
import AssetsDetails from './pages/Assets/assetsDetails';
import SpearParts from './pages/Inventory/SpearParts';
import ReceiveStock from './pages/Inventory/ReceiveStock';
import StockAdjustment from './pages/Inventory/StockAdjustment';
import StockPicking from './pages/Inventory/StockPicking';
import CycleCount from './pages/Inventory/CycleCount';
import PurchaseRequest from './pages/Purchase/Request';
import PurchaseOrderPage from './pages/Purchase/Order';
import Stock from './pages/Purchase/Stock';
import SpearPartsDetails from './pages/Inventory/SpearParts/spearPartsDetails';
import { useAppLoader } from './_common/pageLoader/appLoaderHook';
import { useAuthSync } from './_common/hooks/useAuthSync';
import { useAuthInitialization } from './_common/hooks/useAuthInitialization';
import { useEffect } from 'react';
import Depreciation from './pages/Depreciation';
import WorkRequest from './pages/WorkRequest';
import WorkRequestDetails from './pages/WorkRequest/workRequestDetails';
import WarrantyList from './pages/Warranties';
import WorkOrder from './pages/WorkOrder';
import Checklist from './pages/Checklist';
import ChecklistFormCreate from './pages/Checklist/checklistFormCreate';
import Settings from './pages/Settings';
import SageConnector from './pages/Settings/_components/SageConnector';
import BillComConnector from './pages/Settings/_components/BillComConnector';
import BillComMasterDataSync from './pages/Settings/_components/BillComMasterDataSync';
import SageMasterDataSync from './pages/Settings/_components/SageMasterDataSync';
import SageAssetGroupMaster from './pages/Settings/_components/SageAssetGroupMaster';
import SageAssetsMapping from './pages/Settings/_components/SageAssetsMapping';
import SageOtherMapping from './pages/Settings/_components/SageOtherMapping';
import WorkOrderDetails from './pages/WorkOrder/workOrderDetails';
import SageAssetsInventoryMapping from './pages/Settings/_components/SageAssetsInventoryMapping';
import MaintenanceCalendar from './pages/MaintenanceCalendar';
import MoveLocationHistoryMapView from './pages/Assets/moveLocationMapview';
import StockPickingNew from './pages/Inventory/StockPickingNew';
import Vendor from './pages/Vendor';
import FacilityDetails from './pages/Facilities/facilityDetails';
import WipAssets from './pages/WipAssets';
import SageAssetsExpensesMapping from './pages/Settings/_components/SageAssetsExpensesMapping';
import User from './pages/User';
import UserSettings from './pages/User/userSettings';
import UserTypePermission from './pages/User/userTypePermission';
import Reports from './pages/Reports';
import AssetReportList from './pages/Reports/_components/AssetReportList';
import DepreciationReportList from './pages/Reports/_components/DepreciationReportList';
import StockTransactionReportList from './pages/Reports/_components/StockTransactionReportList';
import StockInventoryBalanceReportList from './pages/Reports/_components/StockInventoryBalanceReportList';
import AdoptionDashboard from './pages/AdoptionDashboard';
import ManagerDashboard from './pages/ManagerDashboard';
import AssetsUptimeReport from './pages/Reports/_components/AssetsUptimeReport';
import AssetsTimeCostReport from './pages/Reports/_components/AssetsTimeCostReport';
import TotalMttrReport from './pages/Reports/_components/TotalMttrReport';
import MtbfReport from './pages/Reports/_components/MtbfReport';
import WarrantiesReport from './pages/Reports/_components/WarrantiesReport';
import FixedAssetAuditorReport from './pages/Reports/_components/FixedAssetAuditorReport';
import LowStockReport from './pages/Reports/_components/LowStockReport';
import SparePartsUsageReport from './pages/Reports/_components/SparePartsUsageReport';
import StockAdjustmentReport from './pages/Reports/_components/StockAdjustmentReport';
import ClosedTasksDetailReport from './pages/Reports/_components/ClosedTasksDetailReport';
import MasterFacility from './pages/Settings/_components/MasterFacility';
import MasterGrower from './pages/Settings/_components/MasterGrower';
import MasterServiceTech from './pages/Settings/_components/MasterServiceTech';
import MasterDepartment from './pages/Settings/_components/MasterDepartment';

function App() {
	const { hideLoader } = useAppLoader();
	
	// Initialize authentication state from localStorage
	useAuthInitialization();
	
	// Initialize cross-tab authentication sync
	useAuthSync();

	useEffect(() => {
		const script = document.createElement("script");
		script.src = `https://dreamztech.atlassian.net/s/e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855-T/vf1kch/b/9/265d2229819fd71f4406f3c6533921a7fe5ca37f796b0196618139498ee71081/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector.js?locale=en-US&collectorId=7cd1a965`;
		script.type = "text/javascript";
		script.defer = true;
		document.body.appendChild(script);

		hideLoader();
	}, [hideLoader]);

	return (
		<Router>
			<div className="App">
				<Routes>
					<Route element={<PublicRoutes />}>
						<Route path={URLS.AUTH.LOGIN} element={<Login />}></Route>
						<Route path={URLS.AUTH.REGISTER} element={<Registration />}></Route>
						<Route path={URLS.AUTH.FORGOT_PASSWORD} element={<ForgotPassword />}></Route>
						<Route path={URLS.AUTH.RESET_PASSWORD} element={<ResetPassword />}></Route>
					</Route>

					<Route element={<PrivateRoutes />}>
						<Route path={URLS.PROFILE} element={<Profile />}></Route>

						<Route path={URLS.HOME} element={<Home />}></Route>
						<Route path={URLS.RM_OVERVIEW} element={<Home />}></Route>
						<Route path={URLS.FACILITIES} element={<Facilities />}></Route>
						<Route path={URLS.FACILITY_DETAILS()} element={<FacilityDetails />}></Route>
						<Route path={URLS.ASSETS} element={<Assets />}></Route>
						<Route path={URLS.ASSETS_DETAILS()} element={<AssetsDetails />}></Route>
						<Route path={URLS.ASSETS_MOVE_MAP_VIEW()} element={<MoveLocationHistoryMapView />}></Route>
						<Route path={URLS.WIPASSETS} element={<WipAssets />}></Route>
						<Route path={URLS.WARRANTIES} element={<WarrantyList />}></Route>
						<Route path={URLS.LEASE_ASSETS} element={<Home />}></Route>
						<Route path={URLS.DEPRECIATION} element={<Depreciation />}></Route>
						<Route path={URLS.MAINTENANCE_CALENDER} element={<MaintenanceCalendar />}></Route>
						<Route path={URLS.WORK_ORDERS} element={<WorkOrder />}></Route>
						<Route path={URLS.WORK_ORDER_DETAILS()} element={<WorkOrderDetails />}></Route>
						<Route path={URLS.WORK_REQUEST} element={<WorkRequest />}></Route>
						<Route path={URLS.WORK_REQUEST_DETAILS()} element={<WorkRequestDetails />}></Route>
						<Route path={URLS.CHECKLISTS} element={<Checklist />}></Route>
						<Route path={URLS.CHECKLIST_CREATE()} element={<ChecklistFormCreate />}></Route>

						<Route path={URLS.INVENTORY.SPEAR_PARTS.LIST} element={<SpearParts />} />
						<Route path={URLS.INVENTORY.SPEAR_PARTS.DETAILS()} element={<SpearPartsDetails />} />

						<Route path={URLS.INVENTORY.RECEIVE_STOCK} element={<ReceiveStock />}></Route>
						<Route path={URLS.INVENTORY.STOCK_ADJUSTMENT} element={<StockAdjustment />}></Route>
						<Route path={URLS.INVENTORY.STOCK_PICKING_OLD} element={<StockPicking />}></Route>
						<Route path={URLS.INVENTORY.STOCK_PICKING} element={<StockPickingNew />}></Route>
						<Route path={URLS.INVENTORY.CYCLE_COUNT} element={<CycleCount />}></Route>
						<Route path={URLS.PURCHASING.REQUEST.LIST} element={<PurchaseRequest />}></Route>
						<Route path={URLS.PURCHASING.ORDER} element={<PurchaseOrderPage />}></Route>
						<Route path={URLS.PURCHASING.STOCK} element={<Stock />}></Route>
						<Route path={URLS.VENDORS} element={<Vendor />}></Route>
						<Route path={URLS.USERS} element={<User />}></Route>
						<Route path={URLS.USERS_SETTING} element={<UserSettings />}></Route>
						<Route path={URLS.USER_TYPE_PERMISSION()} element={<UserTypePermission />}></Route>
						<Route path={URLS.ADOPTION_DASHBOARD} element={<AdoptionDashboard />}></Route>
						<Route path={URLS.MANAGER_DASHBOARD} element={<ManagerDashboard />}></Route>
						<Route path={URLS.REPORTS} element={<Reports />}></Route>
						<Route path={URLS.REPORTS_ASSETS} element={<AssetReportList />}></Route>
						<Route path={URLS.REPORTS_DEPRECIATION} element={<DepreciationReportList />}></Route>
						<Route path={URLS.REPORTS_STOCK_TRANSACTION} element={<StockTransactionReportList />}></Route>
						<Route path={URLS.REPORTS_STOCK_INVENTORY_BALANCE} element={<StockInventoryBalanceReportList />}></Route>
						<Route path={URLS.REPORTS_ASSETS_UPTIME} element={<AssetsUptimeReport />}></Route>
						<Route path={URLS.REPORTS_ASSETS_TIME_COST} element={<AssetsTimeCostReport />}></Route>
						<Route path={URLS.REPORTS_TOTAL_MTTR} element={<TotalMttrReport />}></Route>
						<Route path={URLS.REPORTS_MTBF} element={<MtbfReport />}></Route>
						<Route path={URLS.REPORTS_WARRANTIES} element={<WarrantiesReport />}></Route>
						<Route path={URLS.REPORTS_AUDITOR} element={<FixedAssetAuditorReport />}></Route>
						<Route path={URLS.REPORTS_LOW_STOCK} element={<LowStockReport />}></Route>
						<Route path={URLS.REPORTS_SPARE_PARTS_USAGE} element={<SparePartsUsageReport />}></Route>
						<Route path={URLS.REPORTS_STOCK_ADJUSTMENT} element={<StockAdjustmentReport />}></Route>
						<Route path={URLS.REPORTS_CLOSED_TASKS} element={<ClosedTasksDetailReport />}></Route>

						<Route path={URLS.SETTINGS} element={<Settings />}></Route>
						<Route path={URLS.SETTINGS_SAGE_CONNECTOR} element={<SageConnector />} />
						<Route path={URLS.SETTINGS_BILL_COM_CONNECTOR} element={<BillComConnector />} />
						<Route path={URLS.SETTINGS_BILL_COM_MASTER_DATA_SYNC} element={<BillComMasterDataSync />} />
						<Route path={URLS.SETTINGS_SAGE_MASTER_DATA_SYNC} element={<SageMasterDataSync />} />
						<Route path={URLS.SETTINGS_SAGE_ASSET_GROUP_MASTER} element={<SageAssetGroupMaster />} />
						<Route path={URLS.SETTINGS_SAGE_ASSETS_MAPPING} element={<SageAssetsMapping />} />
						<Route path={URLS.SETTINGS_SAGE_ASSETS_INVENTORY_MAPPING} element={<SageAssetsInventoryMapping />} />
						<Route path={URLS.SETTINGS_SAGE_OTHER_MAPPING} element={<SageOtherMapping />} />
						<Route path={URLS.SETTINGS_SAGE_ASSETS_EXPENSES_MAPPING} element={<SageAssetsExpensesMapping />} />
						<Route path={URLS.SETTINGS_USER_FACILITY} element={<MasterFacility />} />
						<Route path={URLS.SETTINGS_USER_SERVICE_TECH} element={<MasterServiceTech />} />
						<Route path={URLS.SETTINGS_USER_GROWER} element={<MasterGrower />} />
						<Route path={URLS.SETTINGS_USER_DEPARTMENT} element={<MasterDepartment />} />

						<Route path={URLS.ACCOUNT} element={<Home />}></Route>
					</Route>

					<Route path={`*`} element={<Page404 />}></Route>
				</Routes>
			</div>
		</Router>
	);
}

export default App;